<template>
    <div>
        <ValidationObserver ref="observer" v-slot="{ slot: passes }" style="position: absolute;">
            <v-row no-gutters align="center">
                <v-col cols="6" class="pt-8">
                    <modal-cadu
                        :close="close"
                        :width="1131.52"
                        v-model="show"
                        @input="value => cancel()"
                    >
                        <div slot="all" class="pt-10 pb-4 px-10">
                            <div slot="header">
                                <div class="font-primaria headline font-weight-bold pb-4" style="color: #00995D">
                                    {{actionName}} MEDIDA INTERVENTIVA
                                </div>
                            </div>
                            <component-loading style="height: 256px;" :value="isLoading"/>
                            <div slot="body" v-if="!isLoading">
                                <v-row>
                                    <v-col cols="12" sm="12" md="5">
                                        <validation-provider name="tipoIntervencao" rules="max:40|required" mode="eager" v-slot="{ errors }">
                                            <autocomplete-cadu
                                                :errorMessage="errors[0]"
                                                title="Tipo de Intervenção"
                                                v-model="medidaSelecionada.tipoIntervencao.nome"
                                                :items="listaIntervencao.map(el => el.nome)"
                                                :colorText="$vuetify.theme.themes.light.fontColor1"
                                                :disabled="onlyView || action === 'edit'"
                                            />
                                        </validation-provider>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="12" md="4">
                                        <validation-provider name="numeroResolucao" ref="numeroResolucao" rules="numeric|max:10|required" mode="eager" v-slot="{ errors }">
                                            <input-cadu
                                                :errorMessage="errors[0]"
                                                title="Número da Resolução Operacional"
                                                v-model="medidaSelecionada.resolucaoOperacional"
                                                :colorText="$vuetify.theme.themes.light.fontColor1"
                                                :disabled="onlyView"
                                                onlyNumber
                                                max="10"
                                            />
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                            <datepicker-cadu
                                                :validateProviderRules="'dateValidator|required|dateValidatorForPass'"
                                                :menuOpen="menuOpen"
                                                :inputTitle="'Data D.O.U.'"
                                                :inputValue="medidaSelecionada.dataPublicacao"
                                                :showSelectedDate="dataDOUFormatada"
                                                :disabled="onlyView"
                                                @value="value => medidaSelecionada.dataPublicacao = value"
                                                @dateValor="value => medidaSelecionada.dataPublicacao = value"
                                                typeCalendar="date"
                                                width="280"
                                                ref="dataDou"
                                            ></datepicker-cadu>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="12" md="4">
                                        <validation-provider name="prazoValidade" rules="numeric|max:3|required" mode="eager" v-slot="{ errors }">
                                            <input-cadu
                                                :errorMessage="errors[0]"
                                                title="Prazo de Validade (em dias)"
                                                v-model="medidaSelecionada.diasValidade"
                                                :colorText="$vuetify.theme.themes.light.fontColor1"
                                                :disabled="onlyView || action === 'edit'"
                                                onlyNumber
                                                max="3"
                                            />
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="auto" class="pt-9" v-if="action === 'view'">
                                      <checkbox-cadu v-model="medidaSelecionada.vigente" disable>
                                          <div slot="text">
                                              Vigente
                                          </div>
                                      </checkbox-cadu>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4" v-if="action === 'edit'">
                                        <datepicker-cadu
                                            :validateProviderRules="`dateValidator|validatePrazoValidade: ${medidaSelecionada.dataPublicacao}`"
                                            :menuOpen="menuOpen"
                                            :inputTitle="'Data fim de vigência'"
                                            :inputValue="dataFinal"
                                            :showSelectedDate="dataFinalFormatada"
                                            :disabled="onlyView"
                                            @dateValor="value => calcDataFinal(value)"
                                            @value="value => calcDataFinal(value)"
                                            :minDate="medidaSelecionada.dataPublicacao"
                                            typeCalendar="date"
                                            width="280"
                                        ></datepicker-cadu>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                        <ValidationProvider v-slot="{ errors }" rules="max:300">
                                        <textarea-cadu
                                            :errorMessage="errors[0] ? errors[0]: ''"
                                            title="Observações"
                                            v-model="medidaSelecionada.observacao"
                                            :colorText="$vuetify.theme.themes.light.fontColor1"
                                            :disabled="onlyView"
                                            max="300"
                                        />
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>
                            </div>
                            <div slot="footer" class="pt-6">
                              <div v-if="!$vuetify.breakpoint.xs">
                                <v-row v-if="onlyView" justify="end">
                                    <v-col
                                        @click="cancel()"
                                        cols="auto"
                                    >
                                    <button-cadu>
                                        VOLTAR
                                    </button-cadu>
                                    </v-col>
                                </v-row>
                                <v-row align="start" justify="start" v-else>
                                    <v-col cols="auto">
                                        <button-cadu
                                            outline
                                            @click="verifyCancelar()"
                                            v-if="action === 'edit'"
                                        >
                                            CANCELAR
                                        </button-cadu>
                                    </v-col>
                                    <v-col v-if="action === 'add'">
                                      <button-cadu
                                          text="VOLTAR"
                                          @click="cancel"
                                          outline
                                      />
                                    </v-col>
                                    <v-row align="end" justify="end" class="mr-2">
                                        <v-col cols="auto">
                                            <button-cadu
                                                :backColor="$vuetify.theme.themes.light.primary2"
                                                class="px-4"
                                                @click="limparCampos()"
                                            >
                                                LIMPAR
                                            </button-cadu>
                                        </v-col>
                                        <v-col
                                            @click="saveChanges()"
                                            cols="auto"
                                        >
                                            <button-cadu>
                                                SALVAR
                                            </button-cadu>
                                        </v-col>
                                    </v-row>
                                </v-row>
                              </div>
                              <div v-else>
                                <v-row v-if="onlyView" justify="end">
                                    <v-col
                                        @click="cancel()"
                                        cols="12"
                                    >
                                    <button-cadu block>
                                        VOLTAR
                                    </button-cadu>
                                    </v-col>
                                </v-row>
                                <v-row v-else>
                                    <v-col
                                        @click="saveChanges()"
                                        cols="12"
                                    >
                                        <button-cadu block>
                                            SALVAR
                                        </button-cadu>
                                    </v-col>
                                    <v-col cols="12">
                                        <button-cadu
                                            :backColor="$vuetify.theme.themes.light.primary2"
                                            block
                                            @click="limparCampos()"
                                        >
                                            LIMPAR
                                        </button-cadu>
                                    </v-col>
                                    <v-col cols="12" v-if="action === 'edit'">
                                        <button-cadu
                                            outline
                                            block
                                            @click="verifyCancelar()"
                                        >
                                            CANCELAR
                                        </button-cadu>
                                    </v-col>
                                    <v-col cols="12" v-if="action === 'add'">
                                        <button-cadu
                                            block
                                            @click="cancel()"
                                        >
                                            VOLTAR
                                        </button-cadu>
                                    </v-col>
                                </v-row>
                              </div>
                            </div>
                        </div>
                    </modal-cadu>
                </v-col>
            </v-row>
        </ValidationObserver>
      <modal-cancelar
        v-model="showModalCancelar"
        @cancelar-edicao="cancelarEdicao()"
      />
    </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import { mask } from 'vue-the-mask'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import moment from 'moment'
import { cloneDeep, isEqual, assign } from 'lodash'

import TipoIntervencao from '@/services/Dominios/TipoIntervencao'
export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  directives: {
    mask
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    action: {
      type: String,
      required: false
    },
    onlyView: {
      type: Boolean,
      required: true
    },
    medida: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      close: true,
      show: this.value,

      intervencao: '',
      listaIntervencao: [],
      numeroResolucao: '',
      dataDOU: '',
      prazoValidade: '',
      observacoes: '',

      medidaSelecionada: this.medida,
      checkVigente: false,
      checkNaoVigente: false,
      dataFinal: '',

      isLoading: true,
      role: '',

      // DatePicker
      menuOpen: false,
      dataDOUFormatada: '',
      dataDOUBool: true,
      dataFinalFormatada: '',
      dataFinalBool: true,
      cloneAns: {},
      showModalCancelar: false
    }
  },
  async beforeMount () {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role
    this.getTipoIntervencao()
  },
  methods: {
    verifyCancelar () {
      if (!isEqual(this.cloneAns, this.medidaSelecionada)) {
        this.showModalCancelar = true;
      } else {
        this.showModalCancelar = false
        this.$emit('input', false);
      }
    },
    cancelarEdicao () {
      this.showModalCancelar = false
      let obj = {}
      assign(obj, this.cloneAns)
      this.medidaSelecionada = obj
      this.$emit('input', false);
    },
    medidaSelecionadaDOU () {
      if (this.dataDOUBool) {
        this.dataDOUBool = false
        this.dataDOUFormatada = moment(this.medidaSelecionada.dataPublicacao).format('YYYY-DD-MM')
      }
    },
    dataFinalFormat () {
      if (this.dataFinalBool) {
        this.dataFinalBool = false
        this.dataFinalFormatada = moment(this.dataFinal).format('YYYY-DD-MM')
      }
    },
    async getTipoIntervencao () {
      let tipoIntervencao = new TipoIntervencao(this.tokenBearer, this.$appConfig.config.API)

      try {
        let responseTipoIntervencao = await tipoIntervencao.getTipoIntervencao()
        this.listaIntervencao = responseTipoIntervencao.data

        this.isLoading = false
      } catch (err) {
        this.listaIntervencao = []
      }
    },
    async limparCampos () {
      this.medidaSelecionada = {
        id: null,
        tipoIntervencao: {
          nome: this.action === 'add' ? '' : this.medidaSelecionada.tipoIntervencao.nome
        },
        prazoValidade: '',
        status: false,
        observacoes: ''
      }
      this.dataFinal = ''
      this.dataDOUFormatada = ''
      this.dataFinal = ''
      this.dataDOUBool = true
      this.dataFinalBool = true
      this.checkNaoVigente = false
      this.checkVigente = false
      await this.$refs.observer.reset()
    },
    async saveChanges () {
      if (await this.$refs.observer.validate()) {
        let obj = this.mountObject()
        this.$emit('save-changes', obj)
      }
    },
    mountObject () {
      let medidaInterventiva = {
        id: this.medidaSelecionada.id != null ? this.medidaSelecionada.id : null,
        tipoIntervencao: this.listaIntervencao.find(item => item.nome === this.medidaSelecionada.tipoIntervencao.nome),
        resolucaoOperacional: this.medidaSelecionada.resolucaoOperacional,
        dataPublicacao: this.medidaSelecionada.dataPublicacao,
        diasValidade: Number(this.medidaSelecionada.diasValidade),
        observacao: this.medidaSelecionada.observacao
      }
      return medidaInterventiva
    },
    checkName () {
      if (this.medidaSelecionada.status === true) {
        return 'Vigente'
      } else {
        return 'Não Vigente'
      }
    },
    async cancel () {
      this.limparCampos()
      this.show = false
      this.$emit('cancel')
    },
    calcDataFinal (value) {
      this.dataFinal = value
      if (value.length === 10) {
        let ONE_DAY = 1000 * 60 * 60 * 24

        let dataInicialSplit = this.medidaSelecionada.dataPublicacao.split('/')
        let dataInicial = new Date(Number(dataInicialSplit[2]), Number(dataInicialSplit[1] - 1), Number(dataInicialSplit[0])).getTime()

        let dataFinalSplit = this.dataFinal.split('/')
        let dataFinal = new Date(Number(dataFinalSplit[2]), Number(dataFinalSplit[1] - 1), Number(dataFinalSplit[0])).getTime()

        let diferenca = dataFinal - dataInicial
        let diasRestantes = Math.round(diferenca / ONE_DAY)

        if (diasRestantes > 0) {
          this.medidaSelecionada.diasValidade = diasRestantes + 1
        } else {
          this.medidaSelecionada.diasValidade = 0
        }
      }
    }
  },
  computed: {
    // eslint-disable-next-line
    actionName () {
      if (this.action === 'edit') {
        return 'EDITAR'
      }
      if (this.action === 'view') {
        return 'VISUALIZAR'
      }
      if (this.action === 'add') {
        return 'ADICIONAR'
      }
    }
  },
  watch: {
    value () {
      if (this.value) {
        this.cloneAns = cloneDeep(this.medida)
        this.cloneAns.diasValidade = `${this.cloneAns.diasValidade}`
      }
      this.medidaSelecionada = this.medida
      this.show = this.value
    },
    checkVigente () {
      if (this.checkVigente) {
        this.checkNaoVigente = false
        this.medidaSelecionada.status = true
      }
    },
    checkNaoVigente () {
      if (this.checkNaoVigente) {
        this.checkVigente = false
        this.medidaSelecionada.status = false
      }
    }
  }
}
</script>

<style scoped>

</style>
